import { render, staticRenderFns } from "./AppLogo.vue?vue&type=template&id=73fde54f&"
import script from "./AppLogo.vue?vue&type=script&lang=js&"
export * from "./AppLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73fde54f')) {
      api.createRecord('73fde54f', component.options)
    } else {
      api.reload('73fde54f', component.options)
    }
    module.hot.accept("./AppLogo.vue?vue&type=template&id=73fde54f&", function () {
      api.rerender('73fde54f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/AppLogo.vue"
export default component.exports